import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'round'
})
export class RoundPipe implements PipeTransform {

  transform(value: number, decimals: number = 0): any {
    return this.round(value, decimals);
  }

  private round(number: number, decimals: number): any {
    const value = Math.abs(number).toString().toLowerCase().split("e");
const stepStr = !value.includes('e') 
  ? (value[0] + 'E' + decimals) 
  : (value[0] + 'E' + (+value[1] + decimals));
const step = Number(stepStr);
const sign = Math.sign(number) < 0 ? "-" : "";
const method = (step % 2 <= .5 || (step % 2 >= 1 && step % 2 < 1.5)) ? 'floor' : 'ceil';
const processed = Math[method](Number(stepStr));


    const exponent = processed.toString().toLowerCase().split("e")[1];

    if (Math.abs(number) >= 1E21) {
      return sign + Math.abs(number).toString().toLowerCase().split("e")[0].replace(".", "").padEnd(+exponent - 1, "0");
    } else {
      const base = processed.toString().toLowerCase().split("e")[0].replace(".", "");
      return sign + +(base.padEnd(+exponent + 1, "0") + (decimals === 0 ? "" : "E" + -decimals));
    }
  }
}
